// CommandManagerに登録する
export const COMMAND_MANAGER_REGISTER_PROPERTY = {
  CREATE_PROPERTY_MAPPING: 'createPropertyMapping',
  DELETE_PROPERTY_MAPPING: 'deletePropertyMapping',
  CREATE_LOOP: 'createLoop',
  DELETE_LOOP: 'deleteLoop',
  CREATE_PROPERTY_MAPPING_CLIPBOARD_PASTED:
    'createPropertyMappingClipboardPasted',
  CREATE_LOOP_HEADER: 'createLoopHeader',
} as const;
